export default __webpack_public_path__ + "static/media/plato2.adbb68b7.jpg";